import React, { useRef, useState } from 'react'
import SignUpScreen from '../SingupScreen/SignUpScreen';
import './LoginScreen.css'
import Footer from '../../components/Footer';
import NavForHome from '../../components/Nav/NavForHome';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import FAQcomponent from '../../components/FAQcomponent/FAQcomponent';
import { AiFillDollarCircle } from "react-icons/ai";
import { MdGroups } from "react-icons/md";
import { IoHeartSharp } from "react-icons/io5";
import { AiOutlineSafety } from "react-icons/ai";
import JumpingImages from '../../components/jumpingimages';
import PremsiTutorialButton from '../../components/PremsiTutorialButton';
import BenefitsSection from '../../components/BenefitsSection/BenefitsSection';
import ReferralCTA from '../../components/ReferralCTA/ReferralCTA';

function LoginScreen() {
    const [signin, setsignin] = useState(false);
    const [featureshow, setfeatureshow] = useState(1);
    const [showearnings, setshowearnings] = useState(1);
    const myRef = useRef(null)
    const navigate = useNavigate()
    const isMobile = window.innerWidth <= 850;

    const executeScroll = () => myRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    return (
        <>
            <Helmet>
                <title>Premsi - Easily sell your digital content❤️</title>
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />

                <meta name="description" content="Create a Premsi account and use Premsi + sell immediately." />
                <link rel="canonical" href="https://premsi.com/alternativehomepage" />
                <meta property="og:url" content="https://premsi.com/alternativehomepage" />
            </Helmet>
            <NavForHome setsignin={setsignin} signin={signin} />

            <div className='loginscreen' ref={myRef}>
                <div className='loginscreenouterbody hero-overlay'>
                    <div className='loginscreen__body'>
                        {signin ?
                            <>
                                <SignUpScreen />
                                <div style={{ display: "flex", marginTop: 20 }}>
                                    <div style={{ display: "flex", width: "100%", alignItems: "center", justifyContent: "space-around", marginBottom: 20, marginTop: 10 }}>
                                        <a href="https://apps.apple.com/app/apple-store/id6446628909" style={{ cursor: "pointer", display: "flex", alignItems: "center", marginLeft: 20 }} target='_blank'><img loading="lazy" src={require('../../images/appstore.webp')} style={{ cursor: "pointer", height: 45, borderRadius: 5 }} alt="Premsi.com App store link" /></a>
                                        <a href="https://play.google.com/store/apps/details?id=com.Premsi.app" style={{ cursor: "pointer", display: "flex", alignItems: "center", marginRight: 20 }} target='_blank'><img loading="lazy" src={require('../../images/googleplay.webp')} style={{ cursor: "pointer", height: 45, borderRadius: 5, borderColor: "black", borderWidth: 1, borderStyle: "solid" }} alt="Premsi.com Google play store link" /></a>
                                    </div>
                                </div>
                            </>
                            :
                            <>
                                {/*<h1>Sell, Market and explore content</h1>
                                /*<h2 style={{ color: "white" }}>Enjoy / Buy / Sell / Market your digital content</h2>
                                *<h2 style={{ color: "white" }}>Use Premsi on our App and WebApp</h2>*
                                <h3 style={{ color: "white" }}>Join the most monetizable social media!</h3>
                                <h3 style={{ color: "white" }}>Ready to join? Download our App or sign up here for free!</h3>*/}

                                <h1>Create. Enjoy. Share. Earn. All in One Place.</h1>
                                <p className="hero-tagline">Your content, your platform. Sell and earn in one place.</p>

                                <div className="hero-cta">
                                    <a onClick={() => setsignin(true)} href="#" className="btn-hero btn-get-started">Get started</a>
                                </div>

                                <div className="hero-appstore-wrap">
                                    <div className="hero-appstore">
                                        <a href="https://apps.apple.com/app/apple-store/id6446628909" className="hero-appstore__link" target='_blank' rel="noopener noreferrer"><img loading="lazy" src={require('../../images/appstore.webp')} alt="Premsi.com App store link" /></a>
                                        <a href="https://play.google.com/store/apps/details?id=com.Premsi.app" className="hero-appstore__link hero-appstore__link--play" target='_blank' rel="noopener noreferrer"><img loading="lazy" src={require('../../images/googleplay.webp')} alt="Premsi.com Google play store link" /></a>
                                    </div>
                                </div>
                            </>
                        }
                        <div className="hero-trusted">
                            <img loading="lazy" src={require('../../images/creator.webp')} alt="Premsi.com logo app icon" />
                            <h5>Trusted by 2,000<span className="font-body-inline">+</span> creators! | 2M$ paid out</h5>
                        </div>
                    </div>
                    {/* here 4 images that jump */}
                    {isMobile === false ? <JumpingImages /> : null}
                </div >
            </div >

            <div className='whatispremsimainmain'>
                <div className='whatispremsitop'>
                    <h2 className='whatispremsitop__title'>What is Premsi?</h2>
                    <img loading="lazy" src={require('../../images/pblue-min.webp')} className='whatispremsitop__icon' alt="Premsi.com logo app icon" />
                </div>

                <p className='premsiexplanationp'>Premsi is a social media app that lets you sell digital products—like videos, PDFs, courses, and exclusive content—directly to your fans in under 30 seconds, with instant delivery and payouts. 🔥</p>

                {/* here 4 images that jump */}
                {isMobile === true ? <JumpingImages /> : null}

                {/*<div className='whatispremsimainhome'>
                    <div className='whatispremsidivhome'>
                        <p style={{ fontSize: 30, marginTop: -20 }}>⏱</p>
                        <p>Sign Up and Sell in 30sec 🚀</p>
                    </div>

                    <div className='whatispremsidivhome'>
                        <p style={{ fontSize: 30, marginTop: -20 }}>🏦</p>
                        <p>Premsi is free</p>
                        <p>85% daily payout</p>
                    </div>

                    <div className='whatispremsidivhome'>
                        <p style={{ fontSize: 30, marginTop: -20 }}>⭐️</p>
                        <p>Exploring / Marketing / Selling All in One</p>
                    </div>

                    <div className='whatispremsidivhome'>
                        <p style={{ fontSize: 30, marginTop: -20 }}>🔥</p>
                        <p style={{ fontSize: 19 }}>Fans can buy your content without logging in</p>
                    </div>
                </div>*/}

                <div className="premsi-features-section">
                    <div className="premsi-feature">
                        <div className="premsi-feature-icon-wrap"><AiFillDollarCircle size={28} color='#009ffd' /></div>
                        <h3 className="premsi-feature-title">Creative Ownership</h3>
                        <p className="premsi-feature-text">Premsi creators own 100% of their content and keep 85% of all earnings.</p>
                    </div>
                    <div className="premsi-feature">
                        <div className="premsi-feature-icon-wrap"><MdGroups size={28} color='#009ffd' /></div>
                        <h3 className="premsi-feature-title">Inclusivity</h3>
                        <p className="premsi-feature-text">All creators deserve a safe and inclusive space to connect and share.</p>
                    </div>
                    <div className="premsi-feature">
                        <div className="premsi-feature-icon-wrap"><IoHeartSharp size={28} color='#009ffd' /></div>
                        <h3 className="premsi-feature-title">Freedom</h3>
                        <p className="premsi-feature-text">Creators are free to express their most authentic selves through their content.</p>
                    </div>
                    <div className="premsi-feature">
                        <div className="premsi-feature-icon-wrap"><AiOutlineSafety size={28} color='#009ffd' /></div>
                        <h3 className="premsi-feature-title">All<span className="font-body-inline">-</span>In<span className="font-body-inline">-</span>One</h3>
                        <p className="premsi-feature-text">Exploring / Marketing / Selling all on Premsi possible</p>
                    </div>
                </div>

                <PremsiTutorialButton/>

                {/* here have social media icons */}

                {/*<div className='socialbar' >
                    <p style={{ fontSize: 15, opacity: 0.75 }}>seen on</p>
                    <div className='innersocialbigger' >
                        <img className='socialbarimage' alt='Hacker news logo' src={require('../../images/socialforbar/hn.webp')} />
                        <img className='socialbarimage' alt='Twitter X logo' src={require('../../images/socialforbar/x.webp')} />
                    </div>
                    <div className='innersocialbigger' >
                        <img className='socialbarimage' alt='Tiktok logo' src={require('../../images/socialforbar/tt.webp')} />
                        <img className='socialbarimage' alt='Product Hunt logo' src={require('../../images/socialforbar/producthunt.webp')} />
                    </div>
                    <div className='innersocialsmaller' >
                        <img className='socialbarimage' alt='Instagram logo' src={require('../../images/socialforbar/ig.webp')} />
                    </div>
                </div>*/}

                {/* Here start explained our features */}
                <BenefitsSection selectedId={featureshow} onSelect={setfeatureshow} />
                {/* Here end explained our features */}


                {/*<button className='faq__button' onClick={() => (navigate("/faq"))}>Our FAQs</button>*/}
            </div>

            <div className='everyuserdiv'>
                <div className='everyuserdivinner'>
                    <h3>Everyone can easily sell on Premsi in minutes</h3>
                    {/*<h3 style={{ marginBottom: 15 }}>Premsi generated over 450.000$ for creators 💰</h3>*/}
                    {/*<button className='loginnormal__button' onClick={() => (executeScroll(), setsignin(true))}>Let's go</button>*/}
                </div>
            </div>

            <div className='everyuserdivsecond'>
                <div className='everyuserdivinnersecond'>
                    <p style={{ fontSize: 24, fontWeight: "bold", marginTop: 40, color: "white" }}>Fees 💰</p>
                    <p className='priceexplanation'>And all that for 0$. No monthly subscription. No credit card required. Nothing!</p>
                    <p className='priceexplanation'>We only earn once you make money and 85% goes directly to you</p>
                </div>
            </div>

            {/*<div className='explainappdiv'>
                <h2>Easy to use App</h2>
                <div className='explainappinnerdiv'>
                    <div className='explainappthirddiv'>
                        <h4 style={{ color: "black", textAlign: "center", marginBottom: 20 }}>1️⃣ The feed to explore/market</h4>
                        <img loading="lazy" className='explainappthirdimgnormal' src={require('../../images/pic1.webp')} alt="Premsi.com feed to explore" />
                    </div>

                    <div className='explainappthirddiv'>
                        <h4 style={{ color: "black", textAlign: "center", marginBottom: 20 }}>2️⃣ Buy premium messages</h4>
                        <img loading="lazy" className='explainappthirdimgnormal' src={require('../../images/premiummessage.webp')} alt="Premsi.com easily buy premium messages" />
                    </div>

                    <div className='explainappthirddiv'>
                        <h4 style={{ color: "black", textAlign: "center", marginBottom: 20 }}>3️⃣ Easily sell premium messages</h4>
                        <img loading="lazy" className='explainappthirdimg' src={require('../../images/pic2.webp')} alt="Premsi.com easily sell premium messages" />
                    </div>

                    <div className='explainappthirddiv'>
                        <h4 style={{ color: "black", textAlign: "center", marginBottom: 20 }}>4️⃣ Create free/paid subscription groups</h4>
                        <img loading="lazy" className='explainappthirdimg' src={require('../../images/groups1.webp')} alt="Premsi.com easily create free/paid subscription groups" />
                    </div>
                </div>
            </div>*/}

            <div className="premsi-body" style={{ marginTop: 20, marginBottom: 20 }}>
                <div className="premsi-container">
                    <div className="premsi-left-column">
                        <h1 className="premsi-title">
                            <span>How To</span><br /><strong>Get Started</strong>
                        </h1>
                        <button onClick={() => (executeScroll(), setsignin(true))} className="premsi-signup-button">Sign Up</button>
                        <button style={{ marginTop: 10 }} onClick={() => (navigate("/explanation"))} className="premsi-viralitytips-button">Premsi Virality Tips</button>

                    </div>
                    <div className="premsi-right-column">
                        <div className="premsi-card">
                            <h2 className="premsi-card-title">Create an account</h2>
                            <p className="premsi-card-text">To begin sharing your content on Premsi, you'll need to create an account. It's free to sign up, and takes only a few moments.</p>
                        </div>
                        <div className="premsi-card">
                            <h2 className="premsi-card-title">Post free content and create locked messages</h2>
                            <p className="premsi-card-text">You decide if your account is free or paid. Free accounts can still earn via tips and pay-per-view content. With normal posts you can market your locked content or your paid groups.</p>
                        </div>
                        <div className="premsi-card">
                            <h2 className="premsi-card-title">Create content <span className="font-body-inline">&</span> promote your Premsi</h2>
                            <p className="premsi-card-text">Once you're ready, share your store link on social media and let fans know where to find your content.</p>
                        </div>
                        <div className="premsi-card">
                            <h2 className="premsi-card-title">Collect Premsi 🔥 Viral Points</h2>
                            <p className="premsi-card-text">Use the Premsi App and collect Premsi 🔥 Viral Points by liking, commenting, posting, selling, daily logins and much more. The more points you have the more favoured your account gets in our algorithm = You sell more</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* FAQ section */}
            <FAQcomponent />

            <ReferralCTA
                title={<>Refer friends <span className="font-body-inline">&</span> receive 5<span className="font-body-inline">%</span> of their spendings for life 🔥</>}
                subtitle={<>Whenever they subscribe to Premsi<span className="font-body-inline">+</span>, tip someone or buy a premium message you'll earn.</>}
                onButtonClick={() => (executeScroll(), setsignin(true))}
            />

            {/*<div className='explainappdivwhatcreatorsachieved'>
                <h2>What our creators achieve ❤️</h2>

                {showearnings === 1 ?
                    <img loading="lazy" className='creatorsachievedimage' src={require('../../images/pmearnings/1pm.webp')} alt="Premsi.com earnings example" />
                    : (showearnings === 2 ?
                        <img loading="lazy" className='creatorsachievedimage' src={require('../../images/pmearnings/2pm.webp')} alt="Premsi.com earnings example" />
                        : (showearnings === 3 ?
                            <img loading="lazy" className='creatorsachievedimage' src={require('../../images/pmearnings/3pm.webp')} alt="Premsi.com earnings example" />
                            : (showearnings === 4 ?
                                <img loading="lazy" className='creatorsachievedimage' src={require('../../images/pmearnings/4pm.webp')} alt="Premsi.com earnings example" />
                                :
                                <img loading="lazy" className='creatorsachievedimage' src={require('../../images/pmearnings/5pm.webp')} alt="Premsi.com earnings example" />
                            )))}

                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: 14 }}>
                    <div onClick={() => setshowearnings(1)} style={{ cursor: "pointer", height: 14, width: 14, borderRadius: 10, backgroundColor: (showearnings === 1 ? "gray" : "lightgray"), marginRight: 10 }}></div>
                    <div onClick={() => setshowearnings(2)} style={{ cursor: "pointer", height: 14, width: 14, borderRadius: 10, backgroundColor: (showearnings === 2 ? "gray" : "lightgray"), marginRight: 10 }}></div>
                    <div onClick={() => setshowearnings(3)} style={{ cursor: "pointer", height: 14, width: 14, borderRadius: 10, backgroundColor: (showearnings === 3 ? "gray" : "lightgray"), marginRight: 10 }}></div>
                    <div onClick={() => setshowearnings(4)} style={{ cursor: "pointer", height: 14, width: 14, borderRadius: 10, backgroundColor: (showearnings === 4 ? "gray" : "lightgray"), marginRight: 10 }}></div>
                    <div onClick={() => setshowearnings(5)} style={{ cursor: "pointer", height: 14, width: 14, borderRadius: 10, backgroundColor: (showearnings === 5 ? "gray" : "lightgray"), marginRight: 10 }}></div>
                </div>
            </div>*/}

            <div className="community-cta-section">
                <h2 className="community-cta__title">Join our community today 🎉</h2>
                <p className="community-cta__subtitle">Explore all of our exciting features in our App and on our website!</p>
                <button type="button" className="community-cta__button" onClick={() => (executeScroll(), setsignin(true))}>Sign in</button>
                <div className="community-cta__stores">
                    <a href="https://apps.apple.com/app/apple-store/id6446628909" className="community-cta__store-link" target="_blank" rel="noopener noreferrer"><img loading="lazy" src={require('../../images/appstore.webp')} className="community-cta__store-img" alt="Download on the App Store" /></a>
                    <a href="https://play.google.com/store/apps/details?id=com.Premsi.app" className="community-cta__store-link" target="_blank" rel="noopener noreferrer"><img loading="lazy" src={require('../../images/googleplay.webp')} className="community-cta__store-img community-cta__store-img--play" alt="GET IT ON Google Play" /></a>
                </div>
            </div>

            <Footer />
        </>
    )
}

export default LoginScreen




